import React from 'react';
import classNames from 'classnames';
import { PostCard } from './index';

function Posts({ className, spotlightPosts, responsePosts, conclusionPosts }) {
  return (
    <>
      {[
        [spotlightPosts, 'Lead', false, true],
        [responsePosts, 'Response', true, false],
        [conclusionPosts, 'Concluding', true, false],
      ].map(
        ([posts, title, invertTitles, isPrimaryPosts]) =>
          !!posts.length && (
            <div
              className={classNames([
                `${className}__posts`,
                isPrimaryPosts && `${className}__posts--primary`,
              ])}
              key={title}
            >
              <div
                className={classNames([
                  `${className}__posts-title`,
                  'intro-titles',
                  invertTitles && 'intro-titles--lightened',
                ])}
              >
                <div className="intro-titles__label">
                  {title} Essay{posts.length > 1 && 's'}
                </div>
              </div>
              <div className={`${className}__posts-items`}>
                {posts.map((post) => (
                  <PostCard post={post} key={post.slug} />
                ))}
              </div>
            </div>
          ),
      )}
    </>
  );
}

export default Posts;
